<script setup lang="ts">
interface Props {
    color?: string
    icon: string
    size?: string
    type?: string|null,
    utilities?: string|null,
}

withDefaults(defineProps<Props>(), {
    color: 'text-initial',
    size: 'text-inherit',
    type: null,
    utilities: '',
})
</script>

<template>
    <span 
        class="inline-flex items-center"
        :class="[size, color, icon, utilities]"
        aria-hidden="true"
    >
        <i :class="[type, icon]"></i>
    </span>
</template>